import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchAddons,
  fetchAgents,
  fetchAllAceessCategories,
  fetchAllCampaigns,
  fetchAllMembers,
  fetchCentralisedPlans,
  fetchClusterManagers,
  fetchDietPakagesDropdwon,
  fetchExpenseAccountants,
  fetchExpenseProcessManagers,
  fetchGymCategories,
  fetchGymCities,
  fetchInHouseUsers,
  fetchLeadCaptureKeyword,
  fetchLeadFromSource,
  fetchLeadSource,
  fetchMealTimes,
  fetchOperatorValues,
  fetchReceptionistBySlot,
  fetchReceptionistShifts,
  fetchRegularPlans,
  fetchSessions,
  fetchSourceName,
  fetchTrainerCategory,
  fetchTrainerExperienceLevel,
  fetchTrainerExperties,
  fetchTrainerNameBySlot,
  fetchTrainersBySlot,
  fetchUTMParams,
  fetchUsers,
  fetchWorkoutGoals,
  fetchtrainerShifts,
} from "../../data/dropdownApiS";

export const fetchUsersData = createAsyncThunk(
  "api/fetchUsersData",
  async (payload, { getState }) => {
    const { token, qps, pageNo, limit } = payload;
    const response = await fetchUsers(token, qps, pageNo, limit);
    return response;
  }
);

export const fetchInHouseUsersData = createAsyncThunk(
  "api/fetchInHouseUsersData",
  async (payload, { getState }) => {
    const { token, qps, pageNo, limit } = payload;
    const response = await fetchInHouseUsers(token, qps, pageNo, limit);
    return response;
  }
);

export const fetchIndividualTypeData = createAsyncThunk(
  "api/fetchIndividualTypeData",
  async (payload, { getState }) => {
    const { token, qps, pageNo, limit } = payload;
    const response = await fetchInHouseUsers(token, qps, pageNo, limit);
    return response;
  }
);

export const fetchMealTimesData = createAsyncThunk(
  "api/fetchMealTimesData",
  async (payload, { getState }) => {
    const { token, qps, pageNo, limit } = payload;
    const response = await fetchMealTimes(token, qps, pageNo, limit);
    return response;
  }
);

export const fetchDietPakagesDropdwonData = createAsyncThunk(
  "api/fetchDietPakagesDropdwonData",
  async (payload, { getState }) => {
    const { token, qps, pageNo, limit } = payload;
    const response = await fetchDietPakagesDropdwon(token, qps, pageNo, limit);
    return response;
  }
);

export const fetchRegularPlansData = createAsyncThunk(
  "api/fetchRegularPlansData",
  async (payload, { getState }) => {
    const { token, qps, pageNo, limit } = payload;
    const response = await fetchRegularPlans(token, qps, pageNo, limit);
    return response;
  }
);

export const fetchAddonsData = createAsyncThunk(
  "api/fetchAddonsData",
  async (payload, { getState }) => {
    const { token, qps, pageNo, limit } = payload;
    const response = await fetchAddons(token, qps, pageNo, limit);
    return response;
  }
);

export const fetchCampaignDropdown = createAsyncThunk(
  "api/fetchCampaignDropdown",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchAllCampaigns(filters, token);
    return response;
  }
);

export const fetchTrainerShiftsData = createAsyncThunk(
  "api/fetchTrainerShiftsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchtrainerShifts(filters, token);
    return response;
  }
);

export const fetchTrainerBySlotData = createAsyncThunk(
  "api/fetchTrainerBySlotData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchTrainersBySlot(filters, token);
    return response;
  }
);

export const fetchReceptionistBySlotData = createAsyncThunk(
  "api/fetchReceptionistBySlotData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchReceptionistBySlot(filters, token);
    return response;
  }
);

export const fetchTrainerNameBySlotData = createAsyncThunk(
  "api/fetchTrainerNameBySlotData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchTrainerNameBySlot(filters, token);
    return response;
  }
);

export const fetchSessionsData = createAsyncThunk(
  "api/fetchSessionsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchSessions(filters, token);
    return response;
  }
);

export const fetchAgentsData = createAsyncThunk(
  "api/fetchAgentsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchAgents(filters, token);
    return response;
  }
);

export const fetchAllMembersData = createAsyncThunk(
  "api/fetchAllMembersData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchAllMembers(filters, token);
    return response;
  }
);

export const fetchSourceNameData = createAsyncThunk(
  "api/fetchSourceNameData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchSourceName(filters, token);
    return response;
  }
);

export const fetchLeadCaptureKeywordData = createAsyncThunk(
  "api/fetchLeadCaptureKeywordData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchLeadCaptureKeyword(filters, token);
    return response;
  }
);

export const fetchCentralisedPlansData = createAsyncThunk(
  "api/fetchCentralisedPlansData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchCentralisedPlans(filters, token);
    return response;
  }
);

export const fetchLeadSourceData = createAsyncThunk(
  "api/fetchLeadSourceData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchLeadSource(filters, token);
    return response;
  }
);

export const fetchGymCitiesData = createAsyncThunk(
  "api/fetchGymCitiesData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchGymCities(filters, token);
    return response;
  }
);

export const fetchLeadFromSourceData = createAsyncThunk(
  "api/fetchLeadFromSourceData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchLeadFromSource(filters, token);
    return response;
  }
);

export const fetchUTMParamsData = createAsyncThunk(
  "api/fetchUTMParamsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchUTMParams(filters, token);
    return response;
  }
);

export const fetchOperatorValuesData = createAsyncThunk(
  "api/fetchOperatorValuesData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchOperatorValues(filters, token);
    return response;
  }
);

export const fetchExpenseProcessManagersData = createAsyncThunk(
  "dropdown/fetchExpenseProcessManagersData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchExpenseProcessManagers(filters, token);
    return response;
  }
);

export const fetchExpenseAccountantsData = createAsyncThunk(
  "dropdown/fetchExpenseAccountantsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchExpenseAccountants(filters, token);
    return response;
  }
);

export const fetchAllAceessCategoriesData = createAsyncThunk(
  "dropdown/fetchAllAceessCategoriesData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchAllAceessCategories(filters, token);
    return response;
  }
);

export const fetchGymCategoriesData = createAsyncThunk(
  "dropdown/fetchGymCategoriesData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchGymCategories(filters, token);
    return response;
  }
);

export const fetchTrainerExpertiesData = createAsyncThunk(
  "dropdown/fetchTrainerExpertiesData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchTrainerExperties(filters, token);
    return response;
  }
);

export const fetchTrainerCategoryData = createAsyncThunk(
  "dropdown/fetchTrainerCategoryData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchTrainerCategory(filters, token);
    return response;
  }
);

export const fetchTrainerExperienceLevelData = createAsyncThunk(
  "dropdown/fetchTrainerExperienceLevelData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchTrainerExperienceLevel(filters, token);
    return response;
  }
);

export const fetchReceptionistShiftsData = createAsyncThunk(
  "dropdown/fetchReceptionistShiftsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchReceptionistShifts(filters, token);
    return response;
  }
);

export const fetchClusterManagersData = createAsyncThunk(
  "dropdown/fetchClusterManagersData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchClusterManagers(filters, token);
    return response;
  }
);

export const fetchWorkoutGoalsData = createAsyncThunk(
  "api/fetchWorkoutGoalsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchWorkoutGoals(filters, token);
    return response;
  }
);

const dropdownSlice = createSlice({
  name: "dropdown",
  initialState: {
    usersData: null,
    inhouseUsers: null,
    mealTimes: null,
    dietPackagesDropdown: null,
    regularPlans: null,
    addons: null,
    allCampaigns: null,
    trainerShifts: null,
    individualData: null,
    trainersDataBySlot: null,
    receptionistBySlot: null,
    trainerNamesBySlot: null,
    sessions: null,
    agents: null,
    members: null,
    sourceNames: null,
    leadCaptureKeywords: null,
    centralisedPlans: "",
    leadSources: null,
    gymCities: null,
    leadFromSource: null,
    utmParams: null,
    operatorValue: null,
    processManagers: null,
    expenseAccountants: null,

    loading: false,
    error: null,

    allAccessCategories: null,
    allAccessCategoriesLoading: false,
    allAccessCategoriesError: null,

    gymCategories: null,
    gymCategoriesLoading: false,
    gymCategoriesError: null,

    trainerExperties: null,
    trainerExpertiesLoading: false,
    trainerExpertiesError: null,

    trainerCategories: null,
    trainerCategoriesLoading: false,
    trainerCategoriesError: null,

    trainerExperienceLevel: null,
    trainerExperienceLevelLoading: false,
    trainerExperienceLevelError: null,

    receptionistShifts: null,
    receptionistShiftsLoading: false,
    receptionistShiftsError: null,

    clusterManagers: null,
    clusterManagersLoading: false,
    clusterManagersError: null,

    workoutGoals: null,
    workoutGoalsLoading: false,
    workoutGoalsError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsersData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUsersData.fulfilled, (state, action) => {
        state.loading = false;
        state.usersData = action.payload;
      })
      .addCase(fetchUsersData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchInHouseUsersData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchInHouseUsersData.fulfilled, (state, action) => {
        state.loading = false;
        state.inhouseUsers = action.payload;
      })
      .addCase(fetchInHouseUsersData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchMealTimesData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMealTimesData.fulfilled, (state, action) => {
        state.loading = false;
        state.mealTimes = action.payload;
      })
      .addCase(fetchMealTimesData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchDietPakagesDropdwonData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDietPakagesDropdwonData.fulfilled, (state, action) => {
        state.loading = false;
        state.dietPackagesDropdown = action.payload;
      })
      .addCase(fetchDietPakagesDropdwonData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchRegularPlansData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchRegularPlansData.fulfilled, (state, action) => {
        state.loading = false;
        state.regularPlans = action.payload;
      })
      .addCase(fetchRegularPlansData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAddonsData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAddonsData.fulfilled, (state, action) => {
        state.loading = false;
        state.addons = action.payload;
      })
      .addCase(fetchAddonsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchCampaignDropdown.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCampaignDropdown.fulfilled, (state, action) => {
        state.loading = false;
        state.allCampaigns = action.payload;
      })
      .addCase(fetchCampaignDropdown.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchTrainerShiftsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTrainerShiftsData.fulfilled, (state, action) => {
        state.loading = false;
        state.trainerShifts = action.payload;
      })
      .addCase(fetchTrainerShiftsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchIndividualTypeData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchIndividualTypeData.fulfilled, (state, action) => {
        state.loading = false;
        state.individualData = action.payload;
      })
      .addCase(fetchIndividualTypeData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchTrainerBySlotData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTrainerBySlotData.fulfilled, (state, action) => {
        state.loading = false;
        state.trainersDataBySlot = action.payload;
      })
      .addCase(fetchTrainerBySlotData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchReceptionistBySlotData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReceptionistBySlotData.fulfilled, (state, action) => {
        state.loading = false;
        state.receptionistBySlot = action.payload;
      })
      .addCase(fetchReceptionistBySlotData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchTrainerNameBySlotData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTrainerNameBySlotData.fulfilled, (state, action) => {
        state.loading = false;
        state.trainerNamesBySlot = action.payload;
      })
      .addCase(fetchTrainerNameBySlotData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchSessionsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSessionsData.fulfilled, (state, action) => {
        state.loading = false;
        state.sessions = action.payload;
      })
      .addCase(fetchSessionsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAgentsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAgentsData.fulfilled, (state, action) => {
        state.loading = false;
        state.agents = action.payload;
      })
      .addCase(fetchAgentsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllMembersData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllMembersData.fulfilled, (state, action) => {
        state.loading = false;
        state.members = action.payload;
      })
      .addCase(fetchAllMembersData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchSourceNameData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSourceNameData.fulfilled, (state, action) => {
        state.loading = false;
        state.sourceNames = action.payload;
      })
      .addCase(fetchSourceNameData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchLeadCaptureKeywordData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLeadCaptureKeywordData.fulfilled, (state, action) => {
        state.loading = false;
        state.leadCaptureKeywords = action.payload;
      })
      .addCase(fetchLeadCaptureKeywordData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchCentralisedPlansData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCentralisedPlansData.fulfilled, (state, action) => {
        state.loading = false;
        state.centralisedPlans = action.payload;
      })
      .addCase(fetchCentralisedPlansData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchLeadSourceData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLeadSourceData.fulfilled, (state, action) => {
        state.loading = false;
        state.leadSources = action.payload;
      })
      .addCase(fetchLeadSourceData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchGymCitiesData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGymCitiesData.fulfilled, (state, action) => {
        state.loading = false;
        state.gymCities = action.payload;
      })
      .addCase(fetchGymCitiesData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchLeadFromSourceData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLeadFromSourceData.fulfilled, (state, action) => {
        state.loading = false;
        state.leadFromSource = action.payload;
      })
      .addCase(fetchLeadFromSourceData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchUTMParamsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUTMParamsData.fulfilled, (state, action) => {
        state.loading = false;
        state.utmParams = action.payload;
      })
      .addCase(fetchUTMParamsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchOperatorValuesData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOperatorValuesData.fulfilled, (state, action) => {
        state.loading = false;
        state.operatorValue = action.payload;
      })
      .addCase(fetchOperatorValuesData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchExpenseProcessManagersData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchExpenseProcessManagersData.fulfilled, (state, action) => {
        state.loading = false;
        state.processManagers = action.payload;
      })
      .addCase(fetchExpenseProcessManagersData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchExpenseAccountantsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchExpenseAccountantsData.fulfilled, (state, action) => {
        state.loading = false;
        state.expenseAccountants = action.payload;
      })
      .addCase(fetchExpenseAccountantsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchAllAceessCategoriesData.pending, (state) => {
        state.allAccessCategoriesLoading = true;
        state.allAccessCategoriesError = null;
      })
      .addCase(fetchAllAceessCategoriesData.fulfilled, (state, action) => {
        state.allAccessCategoriesLoading = false;
        state.allAccessCategories = action.payload;
      })
      .addCase(fetchAllAceessCategoriesData.rejected, (state, action) => {
        state.allAccessCategoriesLoading = false;
        state.allAccessCategoriesError = action.error.message;
      })

      .addCase(fetchGymCategoriesData.pending, (state) => {
        state.gymCategoriesLoading = true;
        state.gymCategoriesError = null;
      })
      .addCase(fetchGymCategoriesData.fulfilled, (state, action) => {
        state.gymCategoriesLoading = false;
        state.gymCategories = action.payload;
      })
      .addCase(fetchGymCategoriesData.rejected, (state, action) => {
        state.gymCategoriesLoading = false;
        state.gymCategoriesError = action.error.message;
      })

      .addCase(fetchTrainerExpertiesData.pending, (state) => {
        state.trainerExpertiesLoading = true;
        state.trainerExpertiesError = null;
      })
      .addCase(fetchTrainerExpertiesData.fulfilled, (state, action) => {
        state.trainerExpertiesLoading = false;
        state.trainerExperties = action.payload;
      })
      .addCase(fetchTrainerExpertiesData.rejected, (state, action) => {
        state.trainerExpertiesLoading = false;
        state.trainerExpertiesError = action.error.message;
      })

      .addCase(fetchTrainerCategoryData.pending, (state) => {
        state.trainerCategoriesLoading = true;
        state.trainerCategoriesError = null;
      })
      .addCase(fetchTrainerCategoryData.fulfilled, (state, action) => {
        state.trainerCategoriesLoading = false;
        state.trainerCategories = action.payload;
      })
      .addCase(fetchTrainerCategoryData.rejected, (state, action) => {
        state.trainerCategoriesLoading = false;
        state.trainerCategoriesError = action.error.message;
      })

      .addCase(fetchTrainerExperienceLevelData.pending, (state) => {
        state.trainerExperienceLevelLoading = true;
        state.trainerExperienceLevelError = null;
      })
      .addCase(fetchTrainerExperienceLevelData.fulfilled, (state, action) => {
        state.trainerExperienceLevelLoading = false;
        state.trainerExperienceLevel = action.payload;
      })
      .addCase(fetchTrainerExperienceLevelData.rejected, (state, action) => {
        state.trainerExperienceLevelLoading = false;
        state.trainerExperienceLevelError = action.error.message;
      })

      .addCase(fetchReceptionistShiftsData.pending, (state) => {
        state.receptionistShiftsLoading = true;
        state.receptionistShiftsError = null;
      })
      .addCase(fetchReceptionistShiftsData.fulfilled, (state, action) => {
        state.receptionistShiftsLoading = false;
        state.receptionistShifts = action.payload;
      })
      .addCase(fetchReceptionistShiftsData.rejected, (state, action) => {
        state.receptionistShiftsLoading = false;
        state.receptionistShiftsError = action.error.message;
      })

      .addCase(fetchClusterManagersData.pending, (state) => {
        state.clusterManagersLoading = true;
        state.clusterManagersError = null;
      })
      .addCase(fetchClusterManagersData.fulfilled, (state, action) => {
        state.clusterManagersLoading = false;
        state.clusterManagers = action.payload;
      })
      .addCase(fetchClusterManagersData.rejected, (state, action) => {
        state.clusterManagersLoading = false;
        state.clusterManagersError = action.error.message;
      })

      .addCase(fetchWorkoutGoalsData.pending, (state) => {
        state.workoutGoalsLoading = true;
        state.workoutGoalsError = null;
      })
      .addCase(fetchWorkoutGoalsData.fulfilled, (state, action) => {
        state.workoutGoalsLoading = false;
        state.workoutGoals = action.payload;
      })
      .addCase(fetchWorkoutGoalsData.rejected, (state, action) => {
        state.workoutGoalsLoading = false;
        state.workoutGoalsError = action.error.message;
      });
  },
});

export default dropdownSlice.reducer;
